import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hero", label: "Home" },
  { href: "#about", label: "Summary" },
  { href: "#skills", label: "Skills" },
  { href: "#experience", label: "Experience" },
  { href: "#projects", label: "Projects" },
  { href: "#education", label: "Education" },
  { href: "#contact", label: "Contact" },
];

export default function Sidebar() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    if (!isMobileNavOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsMobileNavOpen(false);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isMobileNavOpen]);

  const closeNav = () => setIsMobileNavOpen(false);

  return (
    <>
      {/* Mobile top bar */}
      <header className="sticky top-0 z-40 border-b border-surface-border bg-surface/95 backdrop-blur md:hidden">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="min-w-0">
            <p className="truncate text-base font-semibold text-gradient">Roshan Bhogan</p>
            <p className="truncate text-sm text-gray-400">Full-Stack Developer</p>
          </div>

          <button
            type="button"
            className="rounded-lg border border-accent-cyan/40 px-4 py-2.5 text-sm text-accent-cyan transition-colors hover:bg-accent-cyan/10"
            onClick={() => setIsMobileNavOpen((v) => !v)}
            aria-expanded={isMobileNavOpen}
            aria-controls="mobile-nav"
          >
            {isMobileNavOpen ? "Close" : "Menu"}
          </button>
        </div>

        {isMobileNavOpen && (
          <div id="mobile-nav" className="border-t border-surface-border px-4 py-4 max-h-[70svh] overflow-y-auto">
            <nav className="space-y-1 text-base">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block rounded-lg px-3 py-3 transition-colors hover:bg-accent-cyan/10 hover:text-accent-cyan"
                  onClick={closeNav}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </header>

      {/* Desktop sidebar */}
      <aside className="sticky top-0 hidden h-screen w-72 shrink-0 border-r border-surface-border bg-surface/50 p-8 md:block">
        <h1 className="text-3xl font-bold mb-2 text-gradient">Roshan Bhogan</h1>
        <p className="text-gray-400 mb-8">Full-Stack Developer</p>

        <nav className="space-y-1 text-base">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="group flex items-center gap-2 rounded-lg px-3 py-2 transition-colors hover:bg-accent-cyan/10"
            >
              <span className="text-accent-cyan transition-transform group-hover:translate-x-1">➤</span>
              <span className="group-hover:text-accent-cyan">{link.label}</span>
            </a>
          ))}
        </nav>

        <div className="absolute bottom-8 left-8 right-8">
          <div className="rounded-lg border border-surface-border bg-surface-card p-4">
            <p className="text-xs font-mono text-accent-cyan mb-1">{"> status"}</p>
            <p className="text-sm text-gray-400">Intern @ BharatGo</p>
          </div>
        </div>
      </aside>
    </>
  );
}
